<template>
  <div class="contractmanage">
    <BannerForm
      :video="banner.video"
      :logoSrc="logoSrc"
      title="免费试用"
      showForm
      text="浙江省“最多跑一次”指定电子签供应商"
      bannerTabbox
      viedoFlag
      setHeight="620"
      @setShowSuccessDialog="setShowSuccessDialog"
    >
      <template slot="title">合法可靠的电子合同 签管一体平台</template>
      <template slot="desc">
        电子签署&nbsp;&nbsp;|&nbsp;&nbsp;审批协同&nbsp;&nbsp;|&nbsp;&nbsp;智能管理&nbsp;&nbsp;|&nbsp;&nbsp;业法财一体
      </template>
    </BannerForm>
    <!-- 二屏 -->
    <SectionCard class="screen-two" :isPcFlag="true" title="签署更便捷 管理更简单">
      <p class="desc">
        致力于为企业提供智能电子合同
        <span>“签审+管控”</span>
        解决方案
      </p>
      <div class="content">
        <div class="list-box">
          <div class="item" v-for="(item, index) in screenTwoList" :key="index">
            <p class="one-line">
              <span>{{ item.title }}</span>
              <img :src="item.direction" alt="" />
              <span>{{ item.num }}</span>
            </p>
            <p class="two-line">{{ item.text }}</p>
            <p class="three-line">
              <span v-for="(v, i) in item.desc" :key="i"> {{ v }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">免费试用</div>
          <div class="zxzx" @click="handleCustomerServiceClick({ newCustomerServiceLink: newCustomerServiceLink })">在线咨询</div>
        </div>
      </div>
    </SectionCard>
    <!-- 三屏 -->
    <div class="screen-three">
      <div class="title">穿透合同生命周期的智能化管理方案</div>
      <img class="img-one" src="@/assets/images/landing-contractmanage/three-screen.png" alt="" />
      <div class="img-two">
        <img src="@/assets/images/landing-contractmanage/four-screens.png" alt="" />
      </div>
    </div>
    <!-- 四屏 -->
    <SectionCard class="screen-four" :isPcFlag="true" title="智能合同场景解决方案">
      <p class="desc">采购/销售/项目/人事/租赁/投资/工程等</p>
      <div class="tab">
        <div class="tab-title">
          <div
            class="tab-title-item"
            v-for="(item, index) in screenFourTabTitle"
            :key="index + item"
            @click="activeIndex = index"
            :class="{ active: activeIndex === index }"
          >
            {{ item }}
          </div>
        </div>
        <div class="tab-content" v-for="(item, index) in screenFourTabContent" :key="index" v-show="activeIndex === index">
          <div class="left">
            <div class="td">
              <div class="title">
                <div class="line"></div>
                <div class="text">{{ item.td.title }}</div>
              </div>
              <div class="content">
                <div
                  class="con-item"
                  v-for="(v, i) in item.td.content"
                  :key="i"
                  :class="{ changeClass: v.key === 8, lineClass: v.key === 5 || v.key === 7 }"
                >
                  <p class="square"></p>
                  <p>{{ v.desc }}</p>
                </div>
              </div>
            </div>
            <div class="fa">
              <div class="title">
                <div class="line"></div>
                <div class="text">{{ item.fa.title }}</div>
              </div>
              <div class="content">
                <div class="text">{{ item.fa.text }}</div>
                <div class="tab-item-box">
                  <span class="tab-item" v-for="(v, i) in item.fa.content" :key="i">{{ v }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="changjing">
              <div class="title">
                <div class="line"></div>
                <div class="text">{{ item.changjing.title }}</div>
              </div>
              <div class="content">
                <div
                  class="tab-item"
                  v-for="(v, i) in item.changjing.content"
                  :key="i"
                  :style="{ background: `url(${v.img}) center center / cover no-repeat` }"
                >
                  <div class="desc">{{ v.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">免费试用</div>
          <div class="zxzx" @click="handleCustomerServiceClick({ newCustomerServiceLink: newCustomerServiceLink })">在线咨询</div>
        </div>
      </div>
    </SectionCard>
    <!-- 客户成功案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <div class="kongbai"></div>
    <!-- 底部备案信息 -->
    <div class="footer">
      <div class="footer_con">
        <p>
          公司名称：
          <span>杭州天谷信息科技有限公司</span>
        </p>
        <p>
          销售热线：
          <span>0571-85785223</span>
        </p>
        <p>备案信息：浙ICP备11026113号</p>
        <p>增值电信业务经营许可证浙B2-20180376</p>
        <p>浙公网安备 33010602006438号</p>
      </div>
    </div>
    <!-- 底部小象留资条 -->
    <ScrollForm
      title="企业用户免费领取试用"
      :show="showScrollForm"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      :landingPageName="landingPageName"
    />
    <!-- 弹框留资 -->
    <SuccessFrom v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <UseDialog ref="dialog" />
    <!-- 右侧客服 -->
    <Contact :landingPageName="landingPageName" :source="source" :newCustomerServiceLink="newCustomerServiceLink" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'contractmanage',
  mixins: [qiyuMixin],
  components: {
    Contact: () => import('@/components/Contact.vue'),
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    OrgList: () => import('@/views/semtest/components/pc/OrgList.vue'),
    SuccessFrom: () => import('@/views/semtest/components/pc/successFrom.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    ScrollForm: () => import('@/views/semtest/components/pc/ScrollForm.vue'),
  },
  data() {
    return {
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      showScrollForm: false,
      showSuccessDialog: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      activeIndex: 0,
      logoSrc: require('@/assets/images/sempc-logo.png'),
      banner: {
        video: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanre/banner.mp4',
      },
      screenTwoList: dataList.screenTwoList,
      screenFourTabTitle: dataList.screenFourTabTitle,
      screenFourTabContent: dataList.screenFourTabContent,
      orgList: {
        title: '客户成功案例',
        orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游', '公共服务'],
        imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly', 'ggfw'].map(item => {
          return require(`@/assets/images/${item}.png`)
        }),
      },
      source: 'yinzhangright', // 咨询来源：客服
      newCustomerServiceLink: 'separatEentrance', // 更换咨询客服的链接
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
      this.$refs.newHeader && this.$refs.newHeader.scrollHandle()
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
